import { CSSProperties, useEffect } from 'react';
import { AmrDataRequestRoutesComponent } from './amr-data-request-routes.component';
import { RequestHeaderContainerComponent } from '../shared/request-header/request-header-container.component';
import { useFormContext, useFormState } from 'react-hook-form';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { AmrDataRequestTabsContainerComponent } from './amr-data-request-tabs/amr-data-request-tabs-container.component';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';

const bodyContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 2,
    height: 'calc(100% - 70px)',
    overflow: 'auto'
};

export const AmrDataRequestComponent = () => {
    const { handleEditTitleClick, handleFormSave, handleDataPackageCreation } = useDataRequestContext();
    const { trigger } = useFormContext<IDataRequest>();

    useEffect(() => {
        // force initial validation
        trigger();

        handleDataPackageCreation();
    }, []);

    return (
        <>
            <RequestHeaderContainerComponent
                onEditTitleClick={() => handleEditTitleClick()}
                onSaveClick={() => handleFormSave(false)}
                onSubmitClick={() => handleFormSave(true)}
            />

            <div style={bodyContainerStyle}>
                <AmrDataRequestTabsContainerComponent />
                <AmrDataRequestRoutesComponent />
            </div>
        </>
    );
};
